export const catalogs = [
  {
    id: 1,
    name: "2026 Garments",
    portada:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/2026_Garments/2026_Garments.jpeg",
    document:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/2026_Garments/2026_Garments.pdf",
  },
  {
    id: 2,
    name: "2026 Shoes & Accessories",
    portada:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/2026_Shoes_&_Accessories/2026_Shoes_and_Accessories.jpeg",
    document:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/2026_Shoes_&_Accessories/2026_Shoes_and_Accessories.pdf",
  },
  {
    id: 4,
    name: "Heat retention wear ",
    portada:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/Het_Retention_Wear/Het_Retention_wear.png",
    document:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/Het_Retention_Wear/Heat_retention_wear_2021.pdf",
  },
  {
    id: 3,
    name: "Nikolay® Academy",
    portada:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/Nikolay_Academy/Nikolay_academy.png",
    document:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/Nikolay_Academy/Nikolay_Academy_2019.pdf",
  },
  {
    id: 5,
    name: "Basic Leotards",
    portada:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/Basic_Leotards/Basic_leotards.png",
    document:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/Basic_Leotards/Base_Leotards_Moldova.pdf",
  },
  {
    id: 6,
    name: "Seamless underwear",
    portada:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/Seamless_Underwear/Seamless_underwear.png",
    document:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/catalog/items/Seamless_Underwear/Seamless_underwear.pdf",
  },
];
